import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  section: {
    backgroundColor: '#f0f0f0'
  },
  card: {
    textAlign: 'center'
  },
  toolbar: theme.mixins.toolbar
}))